<script>
import { BPopover } from 'bootstrap-vue';
import Chevron from '../../../js/components/icon/SalesflowChevron.vue';
import Arrow from '../../../js/components/icon/Arrow.vue';

export default {
  components: {
    BPopover,
    Chevron,
    Arrow,
  },

  props: {
    option: {
      type: Object,
      default: {
        name: 'Ordenar'
      }
    },
  },

  data () {
    return {
      isSelectOpen: false,
      isOptionApplied: false,
      selectedOption: { name: '', value: '', order: '' },
      selectedOrder: 'desc',
      chevronDirection: "down",
      options: [
        { value: "title", name: "Ordem alfabética" },
        { value: "created_at", name: "Data de criação" },
        { value: "closed_at", name: "Data de fechamento" },
        // { value: "stagnationDate", name: "Data de estagnação" },
        { value: "value", name: "Valor do negócio" },
        // { value: "probabilityStatus", name: "Status de probabilidade" },
        { value: "updated_at", name: "Última atualização" }
      ],
      popoverOffset: 72.5,
      buttonWidth: 145,
    }
  },

  watch: {
    option(newValue) {
      if(newValue.name === 'Ordenar') {
        this.isOptionApplied = false;
        this.clearSelectedOption();
      }
    }
  },

  computed: {
    isOptionSelected() {
      return this.selectedOption.value.length;
    }
  },

  methods: {
    toggleSelect() {
      this.isSelectOpen = !this.isSelectOpen;
      this.toggleChevron();
    },

    toggleChevron() {
      this.chevronDirection = this.chevronDirection === "down" ? "up" : "down"
    },

    selectOption(option) {
      this.selectedOption = {
        name: option.name,
        value: option.value,
        order: ''
      };
      this.toggleSelect();
      this.$nextTick(() => {
        this.updatePopoverOffset();
      })
    },

    applyOption() {
      this.isOptionApplied = true;
      this.hidePopover();
      this.selectedOption.order = this.selectedOrder;
      this.$emit('optionSelected', this.selectedOption);
    },

    clearSelectedOption() {
      this.selectedOption = {
        name: '',
        value: '',
        order: '',
      };
    },

    selectOrder(order) {
      if(this.selectedOrder === order) return;
      this.selectedOrder = order;
    },

    hidePopover() {
      this.$root.$emit('bv::hide::popover', 'deal-sort-popover');
    },

    onPopoverShow() {
      this.updatePopoverOffset();
      this.$root.$emit('bv::hide::tooltip', 'sort-tooltip');
    },

    onPopoverHide() {
      if (this.isSelectOpen) this.toggleSelect();
      if (!this.isOptionApplied) {
        this.clearSelectedOption();
        this.selectedOrder = 'desc';
      }
      this.$nextTick(() => {
        this.updatePopoverOffset();
      });
    },

    updatePopoverOffset(popoverOffset = 0, buttonWidth = 0) {
      let sortButton = document.getElementById('sort-button');
      let sortPopover = document.getElementById('deal-sort-popover');

      if (popoverOffset) {
        sortPopover = popoverOffset;
      } else if (sortPopover){
        sortPopover = sortPopover.getBoundingClientRect().width;
      }

      if (buttonWidth) {
        sortButton = buttonWidth;
      } else if (sortButton) {
        sortButton = sortButton.getBoundingClientRect().width;
      }

      if (sortButton && sortPopover) {
        const buttonWidth = sortButton;
        this.buttonWidth = buttonWidth;
        const popoverWidth = sortPopover;
        this.popoverOffset = ((popoverWidth - buttonWidth) / 2);
      }
    }
  },

  mounted() {
    Bus.$on('sort-popover-position', () => this.popoverOffset = 59.5);
    Bus.$on('clean-order', () => this.selectedOrder = 'desc');
    window.addEventListener('resize', () => this.updatePopoverOffset());
  },
}
</script>

<template>
  <BPopover
    id="deal-sort-popover"
    target="sort-button"
    placement="bottom"
    :offset="popoverOffset"
    custom-class="popover-container"
    ref="deal-sort-popover"
    triggers="click blur"
    @show="onPopoverShow"
    @hide="onPopoverHide"
  >
    <div class="sort-container">
      <label for="sort-select">{{ __('Ordenar por') }}</label>
      <div class="select-container">
        <div class="select-input" @click="toggleSelect">
          <button>
            <span :class="{ optionSelected: isOptionSelected }">{{ __(selectedOption.name) || __('Selecione') }}</span>
            <Chevron
              color="#71767D"
              :direction="chevronDirection"
            />
          </button>
        </div>
        <div
          v-if="isOptionSelected && !isSelectOpen"
          class="sort-switch-container"
        >
          <button
            :class="['tab-button', 'asc', { active: selectedOrder === 'asc' }]"
            @click="selectOrder('asc')"
          >
            {{ __('Crescente') }}
            <Arrow
              v-if="selectedOrder === 'asc'"
              direction="right"
              color="#FFF"
            />
          </button>
          <button
            :class="['tab-button', 'desc', { active: selectedOrder === 'desc' }]"
            @click="selectOrder('desc')"
          >
            <Arrow
              v-if="selectedOrder === 'desc'"
              direction="left"
              color="#FFF"
            />
            {{ __('Decrescente') }}
          </button>
        </div>
        <div
          v-if="isSelectOpen"
          class="options-container"
        >
          <ul>
            <li v-for="option in options" :key="option.value">
              <span @click="selectOption(option)">
                {{ __(option.name) }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div
        v-if="isOptionSelected"
        class="apply-button-container"
      >
        <span @click="applyOption">
          {{ __('Aplicar') }}
        </span>
      </div>
    </div>
  </BPopover>
</template>

<style scoped lang="scss">
.popover-container {
  border: none;
  border-radius: 16px;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.2) !important;
}

::v-deep .arrow {
  display: none !important;
}

::v-deep .popover-body {
  border-radius: 16px;
  background: #ECECEC;
  padding: 14px 16px;
  width: 264px;
}

.sort-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

label {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
  align-self: self-start;
  margin: 0;
  margin-bottom: 4px;
}

.select-container {
  width: 100%;
  position: relative;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.select-input {
  height: 42px;
  border-radius: 14px;
  border: 1px solid #D1D1D1;

  button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 8px;
    align-items: center;
    padding: 9px 24px;
    border-radius: 14px;
    width: 100%;
    height: 100%;
    border: none;
    background-color: #FFFFFF;

    span {
      font-family: Montserrat;
      font-size: 12px;
      font-weight: 600;
      line-height: 150%;
      color: #71767D;
    }

    & span.optionSelected {
      font-size: 16px;
      font-weight: 400;
      color: #1E2125;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.sort-switch-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 32px;

  .tab-button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    width: 120px;
    height: 32px;
    gap: 4px;
    padding: 10px 0;
    top: 0;
    z-index: 1;
    border: 2px solid #D1D1D1;
    cursor: pointer;
    color: #ADB1B7;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 500;
    line-height: 130%;

    &.active {
      width: 129px;
      background-color: #8869FD;
      border: 2px solid #8869FD;
      color: white;
      cursor: default;
      z-index: 2;
    }

    &.asc {
      left: 0;
      border-radius: 12px 0 0 12px;
      padding-left: 14px;
      padding-right: 28px;

      &.active {
        border-radius: 12px;
        padding: 0;
      }
    }

    &.desc {
      right: 0;
      border-radius: 0 12px 12px 0;
      padding-left: 28px;
      padding-right: 14px;

      &.active {
        border-radius: 12px;
        padding: 0;
      }
    }
  }

  .tab-button:not(.active):hover {
    border-color: #5F33FF;
    color: #5F33FF;
  }
}


.apply-button-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  span {
    color: #71767D;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    line-height: 130%;
    cursor: pointer;
    padding: 4px 6px;
  }

  span:hover {
    color: #5F33FF;
  }
}

.options-container {
  position: absolute;
  display: flex;
  width: 232px;
  padding: 8px 0px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 14px;
  border: 1px solid #D1D1D1;
  background: #FFF;
  top: 46px;
  overflow: hidden;
}

ul {
  width: 100%;
  margin: 0;
  padding: 0;

  li {
    list-style-type: none;
  }

  span {
    display: flex;
    padding: 4px 16px;
    align-items: center;
    align-self: stretch;
    color: #1E2125;
    font-family: Montserrat;
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
    border: none;
    background: #FFF;
    width: 100%;
    text-align: left;
    cursor: pointer;
  }

  span:hover {
    background: #F1F5F9;
  }
}
</style>
